<template>
  <div class="lc">
    <div class="lt-top">
      <div class="main" v-for="(item, index) in cropsData" :key="index">
        <div class="m-item ">
          <p class="title">{{ item.name }}</p>

          <span class="num">{{ item.num1 }}</span>

          <span class="unit">{{ item.unit }}</span>
        </div>
        <div class="line"></div>
        <div class="line2"></div>
        
      </div>
    </div>
    <div ref="cmain1" class="cmain" :style="{ width: '435px', height: '240px' }"></div>
      <img src="../../assets/template3/bar-bg.png" alt="" class="cmain-bg">
  

  </div>
</template>

<script>
export default {
  name: 'template.leftC-temp3',
  data() {
    return {
      cropsData: [
        { name: "总体种植面积", val: "ha", num1: '414', unit: "公顷" },
        { name: "预计产量", val: "kg", num1: '414', unit: "公斤" },
        { name: "作物种类", val: "kind", num1: '414', unit: "种" }
      ],
      myChart: "",
      option: "",
      TmyChart: "",
      Toption: "",
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    cDrawCircle() {
      var echarts = require('echarts');
      var TmyChart = echarts.init(this.$refs.cmain1);
      let data = [
        { value: 450, name: '作物一', itemStyle: { color: '#045cfa' } },
        { value: 800, name: '作物二', itemStyle: { color: '#28c8f7' } },
        { value: 450, name: '作物三', itemStyle: { color: '#00f5b4' } },
        { value: 450, name: '作物四', itemStyle: { color: '#fad452' } },
        { value: 450, name: '作物五', itemStyle: { color: '#ff7062' } },
        { value: 450, name: '作物六', itemStyle: { color: '#57c291' } },
        { value: 450, name: '作物七', itemStyle: { color: '#6c91c4' } },





      ];
      var Toption = {
        legend: {
          orient: 'vertical',
          top: "28%",
          height: '180px',
          right: "0%",
          y: "center",
          itemHeight: 12,
          itemWidth: 12,
          // itemGap:30,
          icon: "rect",
          // itemHeight:"10",
          textStyle: {
            padding: [0, 30, 0, 6],
            lineHeight: 30,
            color: "#fff",
            fontWeight: '400',
            fontSize: '14',
          }
        },
        // 圆环中间的文字
        graphic: [
          {
            type: 'text',
            left: "13%",
            top: '50%',
            style: {
              text: '3450',
              font: 'bolder 30px "pmzd" ',
              fill: '#fff',
              fontFamily: 'pmzd',
              fontSize: 30,
              lingHeight: 17,
            }
          },
          {
            type: 'text',
            left: "15%",
            top: '66%',
            style: {
              text: '种植总数',
              fill: '#969696',
              width: 30,
              height: 30,
              fontSize: 16,
            }
          }
        ],
        series: [
          {
            type: 'pie',
            center: ['22%', '60%'],
            radius: ['58%', '75%'],
            avoidLabelOverlap: false,
            itemStyle: {


              normal: {
                borderColor: '#000',
                borderWidth: 2,
                color: data.itemStyle

              }
            },
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: data
          }
        ]

      };
      Toption && TmyChart.setOption(Toption);
      setInterval(function () {
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000)
    },
  },
  mounted() {
    this.$nextTick(() => {

      this.cDrawCircle(); //需要刷新的数据
    });
  },
};
</script>

<style scoped lang="scss">
.lc {
  width: 435px;
  height: 360px;
  display: flex;
  position: relative;
  padding: 10px 0;
  //  background: pink;
}

.lt-top {
  width: 435px;
  height: 82px;
  margin: 14px 0 0 0;
  background: url('../../assets/template3/title-text-bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  z-index: 1;
}

.main {
  width: 435px;
  display: flex;
  text-align: center;
}

.m-item {
  // flex: 1;
  padding: 12px 0 0 24px;

  .title {
    width: 85px;
    height: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 10px;

  }

  .num {
    width: 36px;
    height: 17px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    margin: 0 6px 0 0;
  }

  .unit {
    width: 24px;
    height: 11px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #CBCBCB;
  }
}

.line {
  width: 1px;
  height: 15px;
  background: #125B68;
  position: absolute;
  left: 146px;
  top: 34px;
}

.line2 {
  width: 1px;
  height: 15px;
  background: #125B68;
  position: absolute;
  right: 156px;
  top: 34px;
}

.cmain {
  //减掉96px的高
  margin-top: 86px;
  position: absolute;
  z-index: 5;
}
.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 36px;
  top: 14px;
}

.cmain-bg{
  width: 240px;
  height: 240px;
  border-radius: 50%;
  position: absolute;
  top: 120px;
  left: -23px;
  z-index: -1
}

</style>